import { SW_CACHED_ROUTES, TWYLL_OFFLINE } from '@/offline/constants'
import { Session } from '@/sessions/models'

export const removeNullSegments = (obj: any) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  for (const key in obj) {
    if (obj[key] === null) {
      delete obj[key]
    } else if (typeof obj[key] === 'object') {
      removeNullSegments(obj[key])
    }
  }

  return obj
}

export const saveSessionsToCache = async (data: { sessions: Session[] }) => {
  try {
    const dataJSON = JSON.stringify(data)
    const headers = {
      'Content-Type': 'application/json',
      'Content-Length': dataJSON.length.toString(),
      'Response-Type': 'basic',
      Vary: 'Accept-Language, Cookie',
    }
    const dataResponse = new Response(dataJSON, {
      status: 200,
      headers,
    })
    const cacheTwyllOffline = await caches.open(TWYLL_OFFLINE)

    await cacheTwyllOffline.put(SW_CACHED_ROUTES.upcomingSessions, dataResponse)
  } catch (e) {
    const errorMessage = e instanceof Error ? e.message : e
    throw new Error(`Failed to save session data to cache: ${errorMessage}`, {
      cause: e,
    })
  }
}
